import { CheckRouterService } from "../services/CheckRouter.service"
import { MessageBox } from 'element-ui';

export default async function auth({ from, next, router, to }) {
    if (!$cookies.get('user_nbtc')) {
        return router.push({ name: 'Login' });
    } else {
        let result = await CheckRouterService.CheckRouter();
        if (result.status != 200 && (result.status === 230 || result.status === 225)) {
            $cookies.remove('user_nbtc')
            router.push({ name: 'Login' })
            return MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            });
        } else {
        const permission = JSON.parse(atob($cookies.get("user_nbtc").permission))
        let user = $cookies.get("user_nbtc")
        let provider_id = user.provider_id;
        let arPath = to.path.split("/");
        if (provider_id) {
            if (arPath[1].toLowerCase() == "admin") {
                // MessageBox.alert('คุณไม่มีสิทธิที่จะเข้าถึงเมนูนี้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                $cookies.remove('user_nbtc');
                return router.push({ name: 'Login' })
            }
        } else {
            if (arPath[1].toLowerCase() == "operator") {
                // MessageBox.alert('คุณไม่มีสิทธิที่จะเข้าถึงเมนูนี้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                $cookies.remove('user_nbtc');
                return router.push({ name: 'Login' })
            }
        }
        switch (to.name) {
            case "Admin":
                return router.push({ name: 'Login' })
                break;
            case "Operator":
                return router.push({ name: 'Login' })
                break;
            case 'Add_admin':
                var add = permission.Manage_admin.includes('add');
                if (!add) {
                    MessageBox.alert('สิทธิการเข้าถึงมีการเปลี่ยนแปลง', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Edit_admin':
                var edit = permission.Manage_admin.includes('edit');
                if (!edit) {
                    MessageBox.alert('สิทธิการเข้าถึงมีการเปลี่ยนแปลง', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Manage_averageAdd':
                var add = permission.Manage_averagetosave.includes('add')
                if (!add) {
                    MessageBox.alert('สิทธิการเข้าถึงมีการเปลี่ยนแปลง', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Manage_averageEdit':
                var edit = permission.Manage_averagetosave.includes('edit')
                if (!edit) {
                    MessageBox.alert('สิทธิการเข้าถึงมีการเปลี่ยนแปลง', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Add_typegroup':
                var typegroup = permission.Typegroup ? permission.Typegroup : []
                var add = typegroup.includes('add') ? true : false
                if (!add) {
                    MessageBox.alert('สิทธิการเข้าถึงมีการเปลี่ยนแปลง', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Edit_typegroup':
                var edit = permission.Typegroup.includes('edit')
                if (!edit) {
                    MessageBox.alert('สิทธิการเข้าถึงมีการเปลี่ยนแปลง', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Report_promotion_mobile_type':
                var status = permission.Report_promotion_mobile_type[1]
                if (status != 'true') {
                    MessageBox.alert('สิทธิการเข้าถึงมีการเปลี่ยนแปลง', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Services_rate':
                var status = permission.Services_rate[1]
                if (status != 'true') {
                    MessageBox.alert('สิทธิการเข้าถึงมีการเปลี่ยนแปลง', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Program_technologies':
                var status = permission.Program_technologies[1]
                if (status != 'true') {
                    MessageBox.alert('สิทธิการเข้าถึงมีการเปลี่ยนแปลง', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Services_change':
                var status = permission.Services_change[1]
                if (status != 'true') {
                    MessageBox.alert('สิทธิการเข้าถึงมีการเปลี่ยนแปลง', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Pro_seconds_G5':
                var status = permission.Pro_seconds_G5[1]
                if (status != 'true') {
                    MessageBox.alert('สิทธิการเข้าถึงมีการเปลี่ยนแปลง', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Promotion_table_avg':
                var status = permission.Promotion_table_avg[1]
                if (status != 'true') {
                    MessageBox.alert('สิทธิการเข้าถึงมีการเปลี่ยนแปลง', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Promotion_percent':
                var status = permission.Promotion_percent[1]
                if (status != 'true') {
                    MessageBox.alert('สิทธิการเข้าถึงมีการเปลี่ยนแปลง', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Services_trends':
                var status = permission.Services_trends[1]
                if (status != 'true') {
                    MessageBox.alert('สิทธิการเข้าถึงมีการเปลี่ยนแปลง', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Fast_internet_home_G9':
                var status = permission.Fast_internet_home_G9[1]
                if (status != 'true') {
                    MessageBox.alert('สิทธิการเข้าถึงมีการเปลี่ยนแปลง', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Services_internet':
                var status = permission.Services_internet[1]
                if (status != 'true') {
                    MessageBox.alert('สิทธิการเข้าถึงมีการเปลี่ยนแปลง', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Fast_internet_home_G11':
                var status = permission.Fast_internet_home_G11[1]
                if (status != 'true') {
                    MessageBox.alert('สิทธิการเข้าถึงมีการเปลี่ยนแปลง', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Fast_internet_home_G12':
                var status = permission.Fast_internet_home_G12[1]
                if (status != 'true') {
                    MessageBox.alert('สิทธิการเข้าถึงมีการเปลี่ยนแปลง', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Reportview_promotion':
                var status = permission.Reportview_promotion[1]
                if (status != 'true') {
                    MessageBox.alert('สิทธิการเข้าถึงมีการเปลี่ยนแปลง', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Report_blockchain':
                var status = permission.Report_blockchain[1]
                if (status != 'true') {
                    MessageBox.alert('สิทธิการเข้าถึงมีการเปลี่ยนแปลง', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Manage_user':
                var status = permission.Manage_user.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Manage_admin':
                var status = permission.Manage_admin.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Manage_operator':
                var status = permission.Manage_operator.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Access_log':
                var status = permission.Access_log.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Typegroup':
                var status = permission.Typegroup.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'ListOperator':
                var status = permission.ListOperator.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Manage_average':
                var status = permission.Manage_averagetosave.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Manage_service':
                var status = permission.Manage_service.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Manage_mobile_service':
                var status = permission.Manage_mobile_service.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Manage_question':
                var status = permission.Manage_question.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Manage_article':
                var status = permission.Manage_article.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Manage_news':
                var status = permission.Manage_news.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Manage_mobile':
                var status = permission.Manage_mobile.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Manage_internet':
                var status = permission.Manage_internet.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Manage_request_mobile':
                    var status = permission.Manage_request_mobile.includes('true')
                    if (!status) {
                        MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                        $cookies.remove('user_nbtc');
                        return router.push({ name: 'Login' })
                    }
                    break;
            case 'Manage_request_internet':
                var status = permission.Manage_request_internet.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;    
            case 'Manage_data':
                var status = permission.Manage_data.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Upload_save':
                var status = permission.Upload_save.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Reportview_promotion':
                var status = permission.Reportview_promotion.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Report_blockchain':
                var status = permission.Report_blockchain.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Popular_proMobile':
                var status = permission.Popular_proMobile.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Popular_proInternet':
                var status = permission.Popular_proInternet.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Report_promotion_ranking':
                var status = permission.Report_promotion_ranking.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'User_behavior':
                var status = permission.User_behavior.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Manage_terms_and_condition':
                var status = permission.Manage_terms_and_condition.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Manage_privacy_data_policy':
                var status = permission.Manage_privacy_data_policy.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
            case 'Manage_security_policy':
                var status = permission.Manage_security_policy.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Manage_cookie_privacy':
                var status = permission.Manage_cookie_privacy.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
            case 'Uteleme':
                var status = permission.Uteleme.includes('true')
                if (!status) {
                    MessageBox.alert('User นี้ไม่สามารถเข้าใช้งานเมนูนี้ได้', 'แจ้งเตือน', { confirmButtonText: 'ตกลง', type: 'warning' });
                    $cookies.remove('user_nbtc');
                    return router.push({ name: 'Login' })
                }
                break;
        }
    }
    return next();
}
}